export default __webpack_public_path__ + "static/media/scanGraphic.7e9047ff.svg";